(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Find-us"] && !Shopify.designMode) return;
  try {
    
  class FindUsSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.results = this.querySelector('[data-find-us-results]');
      this.searchInput = this.querySelector('[data-find-us-search]');
      this.stateSelect = this.querySelector('[data-find-us-state]');
      this.citySelect = this.querySelector('[data-find-us-city]');
      this.serviceSelect = this.querySelector('[data-find-us-service]');
      this.pickupInput = this.querySelector('[data-find-us-pickup]');
      this.appointmentInput = this.querySelector('[data-find-us-appointment]');
      this.resetButtons = this.querySelectorAll('[data-find-us-reset], [data-find-us-empty-reset]');
      this.countNode = this.querySelector('[data-find-us-count]');
      this.emptyNode = this.querySelector('[data-find-us-empty]');

      this.renderJsonStores();
      this.cards = Array.from(this.querySelectorAll('[data-store-card]'));
      this.sortCards();
      this.populateFilters();
      this.applyDefaults();
      this.bindEvents();
      this.filterCards();
    }

    renderJsonStores() {
      const script = this.querySelector('[data-find-us-json]');
      if (!script || !this.results) return;

      const raw = script.textContent.trim();
      if (!raw || raw === '[]') return;

      let parsed;
      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        console.warn('Find us section: stores JSON is not valid.', error);
        return;
      }

      const stores = Array.isArray(parsed) ? parsed : parsed.stores;
      if (!Array.isArray(stores)) return;

      stores.forEach((store) => {
        this.results.insertAdjacentHTML('beforeend', this.storeTemplate(store));
      });
    }

    storeTemplate(store) {
      const data = {
        name: store.name || store.store_name || 'Store location',
        state: store.state || '',
        city: store.city || '',
        postalCode: store.postal_code || store.zip || '',
        address: store.address || '',
        phone: store.phone || '',
        email: store.email || '',
        hours: store.hours || '',
        services: Array.isArray(store.services) ? store.services.join(', ') : store.services || '',
        type: store.type || store.store_type || '',
        badge: store.badge || '',
        image: store.image || store.image_url || '',
        directionsUrl: store.directions_url || store.map_url || '',
        appointmentUrl: store.appointment_url || '',
        pickup: Boolean(store.pickup || store.pickup_available),
        appointment: Boolean(store.appointments || store.appointments_available),
        featured: Boolean(store.featured)
      };

      const searchText = [
        data.name,
        data.address,
        data.city,
        data.state,
        data.postalCode,
        data.services,
        data.type
      ].join(' ').toLowerCase();

      const serviceChips = data.services
        .split(',')
        .map((service) => service.trim())
        .filter(Boolean)
        .slice(0, 5)
        .map((service) => `<span class="find-us__chip find-us__chip--light">${this.escapeHtml(service)}</span>`)
        .join('');

      const phoneHref = data.phone.replace(/[^\d+]/g, '');
      const imageMarkup = this.dataset.showImages === 'true' && data.image
        ? `<div class="find-us__media"><img class="find-us__image" src="${this.escapeAttribute(data.image)}" alt="${this.escapeAttribute(data.name)}" loading="lazy"></div>`
        : '';

      const addressLine = [data.city, data.state].filter(Boolean).join(', ');
      const addressMarkup = data.address
        ? `<p class="find-us__detail">
            <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s7-5.1 7-11a7 7 0 0 0-14 0c0 5.9 7 11 7 11Z"></path><circle cx="12" cy="10" r="2.5"></circle></svg>
            <span>${this.escapeHtml(data.address).replace(/\n/g, '<br>')}${addressLine || data.postalCode ? `<br>${this.escapeHtml(addressLine)} ${this.escapeHtml(data.postalCode)}` : ''}</span>
          </p>`
        : '';

      const hoursMarkup = this.dataset.showHours === 'true' && data.hours
        ? `<p class="find-us__detail">
            <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"></circle><path d="M12 8v4l3 2"></path></svg>
            <span>${this.escapeHtml(data.hours).replace(/\n/g, '<br>')}</span>
          </p>`
        : '';

      const phoneMarkup = data.phone
        ? `<p class="find-us__detail">
            <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.7.6 2.5a2 2 0 0 1-.5 2.1L8 9.5a16 16 0 0 0 6.5 6.5l1.2-1.2a2 2 0 0 1 2.1-.5c.8.3 1.6.5 2.5.6A2 2 0 0 1 22 16.9Z"></path></svg>
            <a href="tel:${this.escapeAttribute(phoneHref)}">${this.escapeHtml(data.phone)}</a>
          </p>`
        : '';

      const emailMarkup = this.dataset.showEmail === 'true' && data.email
        ? `<p class="find-us__detail">
            <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16v14H4z"></path><path d="m4 7 8 6 8-6"></path></svg>
            <a href="mailto:${this.escapeAttribute(data.email)}">${this.escapeHtml(data.email)}</a>
          </p>`
        : '';

      const badges = [
        data.pickup ? `<span class="find-us__chip">${this.escapeHtml(this.dataset.pickupText || 'Pickup available')}</span>` : '',
        data.appointment ? `<span class="find-us__chip">${this.escapeHtml(this.dataset.appointmentText || 'Appointments')}</span>` : '',
        serviceChips
      ].join('');

      const buttons = [
        data.directionsUrl ? `<a class="find-us__button find-us__button--primary" href="${this.escapeAttribute(data.directionsUrl)}" target="_blank" rel="noopener">${this.escapeHtml(this.dataset.directionsLabel || 'Get directions')}</a>` : '',
        data.phone ? `<a class="find-us__button" href="tel:${this.escapeAttribute(phoneHref)}">${this.escapeHtml(this.dataset.callLabel || 'Call')}</a>` : '',
        data.appointmentUrl ? `<a class="find-us__button" href="${this.escapeAttribute(data.appointmentUrl)}">${this.escapeHtml(this.dataset.appointmentLabel || 'Book')}</a>` : '',
        data.email ? `<a class="find-us__button" href="mailto:${this.escapeAttribute(data.email)}">${this.escapeHtml(this.dataset.emailLabel || 'Email')}</a>` : ''
      ].join('');

      return `
        <article
          class="find-us__card${data.featured ? ' find-us__card--featured' : ''}"
          data-store-card
          data-name="${this.escapeAttribute(data.name)}"
          data-state="${this.escapeAttribute(data.state)}"
          data-city="${this.escapeAttribute(data.city)}"
          data-services="${this.escapeAttribute(data.services.toLowerCase())}"
          data-service-list="${this.escapeAttribute(data.services)}"
          data-type="${this.escapeAttribute(data.type)}"
          data-pickup="${data.pickup}"
          data-appointment="${data.appointment}"
          data-search="${this.escapeAttribute(searchText)}"
        >
          ${imageMarkup}
          <div class="find-us__card-body">
            <div class="find-us__card-top">
              <div>
                ${data.badge ? `<p class="find-us__badge">${this.escapeHtml(data.badge)}</p>` : ''}
                <h3 class="find-us__store-name">${this.escapeHtml(data.name)}</h3>
                ${data.type ? `<p class="find-us__store-type">${this.escapeHtml(data.type)}</p>` : ''}
              </div>
              ${data.featured ? `<span class="find-us__featured">${this.escapeHtml(this.dataset.featuredLabel || 'Featured')}</span>` : ''}
            </div>
            <div class="find-us__details">${addressMarkup}${hoursMarkup}${phoneMarkup}${emailMarkup}</div>
            ${badges ? `<div class="find-us__chips">${badges}</div>` : ''}
            ${buttons ? `<div class="find-us__buttons">${buttons}</div>` : ''}
          </div>
        </article>
      `;
    }

    sortCards() {
      if (!this.results || this.dataset.sort === 'manual') return;

      const sortKey = this.dataset.sort;
      this.cards.sort((a, b) => {
        if (sortKey === 'state_city') {
          return `${a.dataset.state} ${a.dataset.city} ${a.dataset.name}`.localeCompare(`${b.dataset.state} ${b.dataset.city} ${b.dataset.name}`);
        }

        return (a.dataset.name || '').localeCompare(b.dataset.name || '');
      });

      this.cards.forEach((card) => this.results.appendChild(card));
    }

    populateFilters() {
      this.populateSelect(this.stateSelect, this.uniqueValues('state'), this.stateSelect?.options[0]?.textContent || 'All states');
      this.updateCityOptions();
      this.populateSelect(this.serviceSelect, this.uniqueServices(), this.serviceSelect?.options[0]?.textContent || 'All services');
    }

    applyDefaults() {
      this.setIfExists(this.stateSelect, this.dataset.defaultState);
      this.updateCityOptions();
      this.setIfExists(this.citySelect, this.dataset.defaultCity);
      this.setIfExists(this.serviceSelect, this.dataset.defaultService);
    }

    bindEvents() {
      [this.searchInput, this.stateSelect, this.citySelect, this.serviceSelect, this.pickupInput, this.appointmentInput].forEach((control) => {
        if (!control) return;
        control.addEventListener('input', () => this.handleFilterChange(control));
        control.addEventListener('change', () => this.handleFilterChange(control));
      });

      this.resetButtons.forEach((button) => {
        button.addEventListener('click', () => this.resetFilters());
      });
    }

    handleFilterChange(control) {
      if (control === this.stateSelect) {
        this.updateCityOptions();
      }

      this.filterCards();
    }

    filterCards() {
      const query = this.normalize(this.searchInput?.value);
      const state = this.normalize(this.stateSelect?.value);
      const city = this.normalize(this.citySelect?.value);
      const service = this.normalize(this.serviceSelect?.value);
      const pickupOnly = Boolean(this.pickupInput?.checked);
      const appointmentOnly = Boolean(this.appointmentInput?.checked);
      let visibleCount = 0;

      this.cards.forEach((card) => {
        const matchesQuery = !query || this.normalize(card.dataset.search).includes(query);
        const matchesState = !state || this.normalize(card.dataset.state) === state;
        const matchesCity = !city || this.normalize(card.dataset.city) === city;
        const matchesService = !service || this.serviceValues(card).some((value) => this.normalize(value) === service);
        const matchesPickup = !pickupOnly || card.dataset.pickup === 'true';
        const matchesAppointment = !appointmentOnly || card.dataset.appointment === 'true';
        const visible = matchesQuery && matchesState && matchesCity && matchesService && matchesPickup && matchesAppointment;

        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (this.countNode) {
        const label = visibleCount === 1 ? this.dataset.countSingular : this.dataset.countPlural;
        this.countNode.textContent = `${visibleCount} ${label || 'locations'}`;
      }

      if (this.emptyNode) {
        this.emptyNode.hidden = visibleCount !== 0;
      }
    }

    resetFilters() {
      if (this.searchInput) this.searchInput.value = '';
      if (this.stateSelect) this.stateSelect.value = '';
      this.updateCityOptions();
      if (this.citySelect) this.citySelect.value = '';
      if (this.serviceSelect) this.serviceSelect.value = '';
      if (this.pickupInput) this.pickupInput.checked = false;
      if (this.appointmentInput) this.appointmentInput.checked = false;
      this.filterCards();
    }

    updateCityOptions() {
      if (!this.citySelect) return;

      const selectedState = this.normalize(this.stateSelect?.value);
      const currentCity = this.citySelect.value;
      const cities = this.cards
        .filter((card) => !selectedState || this.normalize(card.dataset.state) === selectedState)
        .map((card) => card.dataset.city)
        .filter(Boolean);

      this.populateSelect(this.citySelect, this.sortValues([...new Set(cities)]), this.citySelect.options[0]?.textContent || 'All cities');
      this.setIfExists(this.citySelect, currentCity);
    }

    populateSelect(select, values, firstLabel) {
      if (!select) return;

      const currentValue = select.value;
      select.innerHTML = '';
      select.appendChild(new Option(firstLabel, ''));

      values.forEach((value) => {
        select.appendChild(new Option(value, value));
      });

      this.setIfExists(select, currentValue);
    }

    uniqueValues(key) {
      return this.sortValues([...new Set(this.cards.map((card) => card.dataset[key]).filter(Boolean))]);
    }

    uniqueServices() {
      return this.sortValues([...new Set(this.cards.flatMap((card) => this.serviceValues(card)).filter(Boolean))]);
    }

    serviceValues(card) {
      return (card.dataset.serviceList || card.dataset.services || '')
        .split(',')
        .map((service) => service.trim())
        .filter(Boolean);
    }

    sortValues(values) {
      return values.sort((a, b) => a.localeCompare(b));
    }

    setIfExists(select, value) {
      if (!select || !value) return;
      const option = Array.from(select.options).find((item) => this.normalize(item.value) === this.normalize(value));
      if (option) select.value = option.value;
    }

    normalize(value = '') {
      return String(value).trim().toLowerCase();
    }

    escapeHtml(value = '') {
      const div = document.createElement('div');
      div.textContent = String(value);
      return div.innerHTML;
    }

    escapeAttribute(value = '') {
      return this.escapeHtml(value).replace(/"/g, '&quot;');
    }
  }

  if (!customElements.get('find-us-section')) {
    customElements.define('find-us-section', FindUsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
